// removed by extract-text-webpack-plugin
module.exports = {"list":"app-23lOzK70","item":"app-oG2AjoBm","meta":"app-2Bu0pa5_","avatar":"app-3L9jG049","read":"app-Z63gpnGV","title":"app-1ixVsuxH","description":"app-1NKyA9yP","datetime":"app-3NfgAcm_","extra":"app-2ywPA8pp","notFound":"app-2z8TQQPA","clear":"app-3JCz5Owq"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-components/noticeIcon/NoticeList.less
// module id = 680
// module chunks = 0